import {FAILURE, PENDING, SUCCESS} from '../../constants'

const ACTION = 'GET_TEMPLATES'

export const GTS_FAILURE = `${ACTION}_${FAILURE}`
export const GTS_PENDING = `${ACTION}_${PENDING}`
export const GTS_SUCCESS = `${ACTION}_${SUCCESS}`

const ACTIONNEXTTEMPLATES = 'GET_NEXT_TEMPLATES'

export const GNTS_FAILURE = `${ACTIONNEXTTEMPLATES}_${FAILURE}`
export const GNTS_PENDING = `${ACTIONNEXTTEMPLATES}_${PENDING}`
export const GNTS_SUCCESS = `${ACTIONNEXTTEMPLATES}_${SUCCESS}`

const DELETE_ACTION = 'DELETE_TEMPLATE'

export const DT_FAILURE = `${DELETE_ACTION}_${FAILURE}`
export const DT_PENDING = `${DELETE_ACTION}_${PENDING}`
export const DT_SUCCESS = `${DELETE_ACTION}_${SUCCESS}`

const GET_ACTION = 'GET_TEMPLATE'

export const GT_FAILURE = `${GET_ACTION}_${FAILURE}`
export const GT_PENDING = `${GET_ACTION}_${PENDING}`
export const GT_SUCCESS = `${GET_ACTION}_${SUCCESS}`

const UPDATE_ACTION = 'UPDATE_TEMPLATE'

export const UT_FAILURE = `${UPDATE_ACTION}_${FAILURE}`
export const UT_PENDING = `${UPDATE_ACTION}_${PENDING}`
export const UT_SUCCESS = `${UPDATE_ACTION}_${SUCCESS}`

const UPDATE_AUDIT_COUNT_ACTION = 'UPDATE_AUDITS_COUNT'

export const UTC_FAILURE = `${UPDATE_AUDIT_COUNT_ACTION}_${FAILURE}`
export const UTC_PENDING = `${UPDATE_AUDIT_COUNT_ACTION}_${PENDING}`
export const UTC_SUCCESS = `${UPDATE_AUDIT_COUNT_ACTION}_${SUCCESS}`
